import { checkAccessRights, checkModuleAccess } from '@/modules'
import { USER_RIGHTS, SUBSCRIPTION_MODULES } from '@/modules/base/util/constants'
import { MultiSelectTypeOptions, MultiSelectTypes } from '@/components/multi-select/constants'

export const getGroups = (userInfo, isTaxConsultant): Array<{ type: MultiSelectTypes, label: string }> => {
  const defaultGroups = [
    MultiSelectTypeOptions.all,
  ]

  const hasUserModuleAccess = checkAccessRights(USER_RIGHTS.MEMBERS.READ, userInfo)
  const hasClientModuleAccess = checkModuleAccess(SUBSCRIPTION_MODULES.CLIENTS)
  const hasCustomerModuleAccess = checkModuleAccess(SUBSCRIPTION_MODULES.CUSTOMERS)
  const hasSupplierModuleAccess = checkModuleAccess(SUBSCRIPTION_MODULES.SUPPLIERS)

  if (hasUserModuleAccess) {
    defaultGroups.push(MultiSelectTypeOptions.user)
  }
  if (hasClientModuleAccess && isTaxConsultant) {
    defaultGroups.push(MultiSelectTypeOptions.client)
  }
  if (hasCustomerModuleAccess) {
    defaultGroups.push(MultiSelectTypeOptions.customer)
  }
  if (hasSupplierModuleAccess) {
    defaultGroups.push(MultiSelectTypeOptions.supplier)
  }

  return defaultGroups
}
